function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "json",
  d: "M143,6c2.7,0.7,5.4,1.5,8.1,2.2c20,5.6,35.6,17.6,46.7,34.7c19.7,30.4,24,63.8,16.1,98.8 c-3.6,16.2-12.5,29.7-24.8,40.8C177.5,193,163.7,198.2,148,198c-1.5,0-3-0.2-4.5-0.4c-1.1-0.2-2.1-0.6-3.9-1.1 c2-1.4,3.4-2.5,4.8-3.5c36.1-25.4,40.1-82,7.9-112.3c-17.4-16.3-37.3-19.1-58.7-10C70.2,80.8,57.1,100,51.4,124 c-7.3,30.6-4.1,60.7,8.8,89.4c8,17.8,20.7,31.7,38,41.1c1,0.5,1.9,1.2,2.8,2.1c-13-3.3-25-8.9-36.1-16.3 c-32.7-21.9-52.3-52-56.9-91.4c-0.2-1.3-0.6-2.6-0.9-3.8c0-7.3,0-14.7,0-22c0.3-1.1,0.7-2.2,0.9-3.4C16.3,64.4,48,29,100.3,11.2 C107.8,8.6,116,7.7,124,6C130.3,6,136.7,6,143,6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "json",
  d: "M131,262c-5.3-1.4-10.7-2.5-15.8-4.3c-22.9-8.1-40.2-22.8-50.5-44.9c-13.3-28.6-16.3-58.8-8.5-89.3 c5.9-23.2,19.5-41.1,42.7-50.1c9.2-3.5,18.7-4.3,29.5-1.9c-2,1.4-3.4,2.4-4.7,3.4c-34.3,24.6-39.3,79-10.4,109.7 c23.4,24.9,53.1,20.5,72.8,6.2c20.7-15.1,31.8-35.9,35-61c2.6-20.3,0.4-40.2-5.4-59.8c-7-23.4-18.5-38.5-44.5-58.1 c3,1,4.7,1.4,6.4,2.1c47,19.1,76.8,52.4,83.8,103.6c9.3,67.3-39.3,132-106.5,142.2c-4.6,0.7-9.2,1.3-13.8,2 C137.7,262,134.3,262,131,262z"
}));

function SvgJson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 268 269",
    style: {
      enableBackground: "new 0 0 268 269"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJson);
export default __webpack_public_path__ + "static/media/json.4f70d1fe.svg";
export { ForwardRef as ReactComponent };